/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * 
 * @param {Question} question
 * @returns {*[]}
 */
export const validateTitleAndKey = (question) => {
    let errors = [];
    const type = question?.type;
    const key = question?.key;
    const prompt = question?.prompt;
    // const label = question?.label;
    // const guid = question?.guid;
    if (!prompt && !key) {
        errors.push(`Question "${key || type || ""}" requires title and key`);
    } else if (!key) {
        errors.push(`Question "${prompt || ""}" requires key`);
    } else if (!prompt) {
        errors.push(`Question "${key || type || ""}" requires title`);
    }
    return errors;
};


/** 
 * @param {Question} question
 * @return {*[]}
 * */
export const validateTitle = (question) => {
    const errors = [];
    const prompt = question?.prompt;
    const type = question?.type;
    // const label = question?.label;
    const key = question?.key;
    if (!prompt) {
        errors.push(`Question "${key || type || ""}" requires title`);
    }
    return errors;
};
